import React, { PureComponent } from 'react';
import { IconButton } from 'components/buttons';
import { Close } from 'components/SvgIcons';
import './style.scss';

class UsersMappingLine extends PureComponent {
    state = {};

    constructor(props) {
        super(props);
    }

    handleDeleteUser = () => {
        let { userConfig, onDeleteUser, index } = this.props;
        onDeleteUser(userConfig.IdFM, userConfig.IdExternal, index);
    };

    render() {
        let { userConfig, fmUsers, extUsers } = this.props;
        return (
            <div className="users-mapping-line">
                <div className="users-mapping-fm-user">
                    {fmUsers[userConfig.IdFM] ? fmUsers[userConfig.IdFM].name : ''}
                </div>
                <div className="users-mapping-ext-user">
                    {extUsers[userConfig.IdExternal] ? extUsers[userConfig.IdExternal].name : ''}
                </div>
                <div className="users-mapping-delete-user">
                    <IconButton onClick={this.handleDeleteUser} icon={<Close />} />
                </div>
            </div>
        );
    }
}

export default UsersMappingLine;
